import type { CityConfig } from "../city-template/types";

export const manassasVaConfig: CityConfig = {
  city: "Manassas",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "manassas-va",
  route: "/manassas-va",
  title: "Emergency Passport Manassas, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Manassas, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Prince William County, Manassas Park, and the Northern Virginia corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Manassas, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Prince William County, Manassas Park, or the Northern Virginia corridor? We help Manassas travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Manassas%20Virginia%20historic%20downtown%20with%20old%20town%20charm%2C%20brick-lined%20streets%20and%20Victorian-era%20architecture%2C%20the%20historic%20Manassas%20Courthouse%20in%20the%20background%2C%20vibrant%20small%20town%20atmosphere%20with%20tree-lined%20sidewalks%2C%20the%20Manassas%20National%20Battlefield%20Park%20area%20visible%20beyond%20the%20town%20center%2C%20warm%20golden%20hour%20lighting%20with%20the%20Virginia%20countryside%2C%20professional%20photography%20showcasing%20Northern%20Virginia%20independent%20city%20with%20Civil%20War%20heritage%20and%20modern%20suburban%20charm%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape&width=1800&height=700&seq=manassas-va-hero-001&orientation=landscape",
  heroImageAlt: "Manassas Virginia historic downtown with Victorian architecture and the Manassas National Battlefield Park visible",
  geoPosition: "38.7509;-77.4751",
  geoPlacename: "Manassas, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 30 miles southeast of Manassas via I-66",
  },
  nearbyCitiesZips: [
    { name: "Manassas", zips: "20110, 20111, 20112, 20113, 20109" },
    { name: "Manassas Park", zips: "20111" },
    { name: "Prince William County", zips: "20110, 20111, 20112, 20181, 20182, 20185, 20186, 20187, 20188" },
    { name: "Bristow", zips: "20136" },
    { name: "Haymarket", zips: "20169" },
    { name: "Dale City", zips: "20125, 20126, 20193" },
    { name: "Woodbridge", zips: "22191, 22192, 22193, 22194, 22195" },
    { name: "Gainesville", zips: "20155, 20156" },
    { name: "Centreville", zips: "20120, 20121, 20122" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22034, 22035, 22036, 22037, 22038, 22039" },
    { name: "Warrenton", zips: "20186, 20187, 20188" },
    { name: "Fredericksburg", zips: "22401, 22402, 22403, 22404, 22405, 22406, 22407, 22408, 22412" },
    { name: "Leesburg", zips: "20175, 20176, 20177, 20178" },
    { name: "Sterling", zips: "20164, 20165, 20166, 20167" },
    { name: "Ashburn", zips: "20146, 20147, 20148, 20149" },
    { name: "Herndon", zips: "20170, 20171, 20172, 20192" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Prince William County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Prince William County Hub", desc: "Serving Manassas, Manassas Park, Bristow, Haymarket, and Gainesville" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Woodbridge VA passport services", route: "#" },
    { name: "Fredericksburg VA passport services", route: "/fredericksburg-va" },
    { name: "Fairfax VA passport services", route: "/fairfax-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Manassas remotely via secure courier. We do not have a walk-in office in Manassas — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Manassas and Prince William County travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Manassas and Prince William County including Manassas Park, Bristow, Haymarket, Dale City, and Gainesville",
  serviceAreaIntro: "From the historic Old Town Manassas to the rolling Virginia countryside of Prince William County, from the bustling communities of Manassas Park and Bristow to the growing suburbs of Haymarket and Gainesville, from the family neighborhoods of Dale City to the western edges of Fairfax County — Fast Passport Center serves every corner of Manassas and the surrounding Northern Virginia corridor. We regularly help travelers from Manassas Park, Woodbridge, and Centreville get their passports fast.",
  nearbyCitiesIntro: "We serve all Manassas neighborhoods and Prince William County including Manassas Park, Bristow, Haymarket, Dale City, Gainesville, and the surrounding Northern Virginia corridor.",
  howItWorksIntro: "Most Manassas travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Manassas travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Manassas and Prince William County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Manassas? Here are the most common ones we hear from Prince William County travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Manassas international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jessica R.",
      location: "Manassas, VA",
      rating: 5,
      text: "I live near Old Town Manassas and needed an emergency passport for a business trip to Germany with 5 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Sudley Road and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Thomas M.",
      location: "Manassas Park, VA",
      rating: 5,
      text: "As a Manassas Park resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Prince William County families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah K.",
      location: "Bristow, VA",
      rating: 5,
      text: "First passports for my two kids before a family trip to Mexico. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 6 days. For Bristow families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "David P.",
      location: "Manassas, VA",
      rating: 5,
      text: "Lost my passport 4 days before a business trip to London. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my career and my trip. Manassas professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "manassas-va-1",
      name: "Manassas Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Manassas",
      state: "VA",
      zip: "20110",
      phone: "(703) 368-4141",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Manassas",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Manassas facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "manassas-va-2",
      name: "Woodbridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Woodbridge",
      state: "VA",
      zip: "22191",
      phone: "(703) 494-4084",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Woodbridge, south of Manassas",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Dale City and Woodbridge. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "manassas-va-3",
      name: "Gainesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Gainesville",
      state: "VA",
      zip: "20155",
      phone: "(703) 754-6331",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Gainesville, west of Manassas",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Prince William County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "manassas-va-4",
      name: "Centreville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Centreville",
      state: "VA",
      zip: "20120",
      phone: "(703) 830-8081",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Centreville, north of Manassas",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Centreville and Fairfax County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "manassas-va-5",
      name: "Prince William County Clerk",
      type: "County Clerk",
      address: "1 County Complex Ct",
      city: "Woodbridge",
      state: "VA",
      zip: "22192",
      phone: "(703) 792-7742",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Woodbridge, Prince William County",
      website: "https://www.pwcgov.org",
      websiteLabel: "Prince William County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "manassas-va-6",
      name: "Northern Virginia Community College — Manassas",
      type: "Campus Resource",
      address: "6901 Sudley Rd",
      city: "Manassas",
      state: "VA",
      zip: "20109",
      phone: "(703) 257-6600",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Manassas, near NVCC",
      website: "https://www.nvcc.edu",
      websiteLabel: "NVCC Manassas",
      notes: "Not a passport acceptance facility, but helpful for students and international program participants. Check with student services.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 1 hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Manassas photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Northern Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Manassas applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Manassas families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Manassas travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Manassas or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Manassas address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Manassas before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Manassas for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from Prince William County." },
    { q: "How fast can I renew my passport in Manassas?", a: "Fast Passport Center offers fast passport renewal in Manassas in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Manassas?", a: "The nearest regional passport agency to Manassas is the Washington Passport Agency, located approximately 30 miles southeast in downtown Washington, DC via I-66. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Manassas." },
    { q: "Can I get a same-day passport appointment near Manassas?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Manassas residents." },
    { q: "Can I expedite a child passport in Manassas?", a: "Yes. Fast Passport Center expedites child passports in Manassas for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Manassas and Prince William County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Manassas with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Manassas?", a: "With Fast Passport Center's emergency courier service, Manassas travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Manassas?", a: "Popular options include the Manassas Main Post Office (20110), Woodbridge Post Office (22191), Gainesville Post Office (20155), and Centreville Post Office (20120). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Manassas Park, Bristow, or Haymarket?", a: "We serve the entire Prince William County including Manassas Park, Bristow, Haymarket, Dale City, and Gainesville. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Manassas?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Manassas", address: "10100 Sudley Manor Dr, Manassas, VA 20109", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Manassas", address: "9200 Sudley Rd, Manassas, VA 20110", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Manassas", address: "10694 Crestwood Dr, Manassas, VA 20109", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Woodbridge", address: "13280 Gordon Blvd, Woodbridge, VA 22191", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Centreville", address: "5801 Trinity Pkwy, Centreville, VA 20120", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Gainesville", address: "7535 Linton Hall Rd, Gainesville, VA 20155", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Manassas",
      address: "10100 Battleview Pkwy, Manassas, VA 20109",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Woodbridge",
      address: "2731 Merrilee Dr, Fairfax, VA 22031",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Centreville",
      address: "14958 Jefferson Davis Hwy, Woodbridge, VA 22191",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves western Fairfax County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Located approximately 25 miles northeast of Manassas",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The closest major international airport to Manassas. International and domestic flights. Accessible via I-66 and the Dulles Toll Road.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National Airport",
      distance: "Located approximately 30 miles east of Manassas",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Regional hub for DC area. Accessible via I-66 and I-395.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Located approximately 90 miles south of Manassas",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "Regional hub for Central Virginia. Accessible via I-95.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Manassas and Prince William County residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Prince William County Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.pwcgov.org/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Prince William County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.pwcgov.org/" },
  ],
};